<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:stops="{ item }">
        <div>
          {{ item.stops.map((s) => s.name)?.join(" -> ") }}
        </div>
      </template>
      <template v-slot:vehicle="{ item }">
        <div>
          <span v-if="item?.vehicle_registration_no.length > 0">
            <span v-if="item?.vehicle_registration_no.length > 1">
              <span>{{ item?.vehicle_registration_no[0] }}</span>
              <span class="text-muted">
                (+{{ item?.vehicle_registration_no.length - 1 }} Vehicles)
              </span>
            </span>
            <span v-else>
              <span>
                {{ item?.vehicle_registration_no[0] }}
              </span>
              <span class="text-muted"> (Vehicle) </span>
            </span>
          </span>
        </div>
      </template>
      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
          <v-card v-if="authUser.isAdmin">
  
          </v-card>
        </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <create-routes
            v-if="isCreate"
            :filter-options="options"
          />

          <edit-routes
            v-if="(isEdit || isView) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          />
          <!-- <confirmation-modal
              v-if="isDelete"
              :is-visible="deleteModal"
              :toggle="toggleDeleteModal"
              :row="selectedRow"
            /> -->
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    CreateRoutes: () => import("./dialogs/CreateRoutes.vue"),
    EditRoutes: () => import("./dialogs/EditRoutes.vue"),
    //   ConfirmationModal: () =>
    //     import("@/components/Modals/ConfirmationModal.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      ocppIdModal: false,
      permissions: {
        view: "user",
        create: "users.list",
        edit: "users.list",
        delete: "",
      },
      filters: {},
      subFilters: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "routes/getLoading",
      meta: "routes/getMeta",
      list: "routes/getList",
      //
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: this.$t("name"),
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
        },
        {
          text: this.$t("stops"),
          align: "left",
          sortable: false,
          value: "stops",
        },
        {
          text: this.$t("vehicle"),
          align: "left",
          sortable: false,
          value: "vehicle",
        },
        {
          text: this.$t("total_sla"),
          align: "left",
          sortable: true,
          value: "sla_target",
        },
        {
          text: this.$t("cutoff_time"),
          align: "left",
          sortable: false,
          value: "cutoff_time",
        },

        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return [""];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {
    // this.$store.dispatch("csmsChargeStations/setLoadingValue", true);
  },
  beforeDestroy() {
    const params = {
      name: "routes",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options };

      await this.$store.dispatch("routes/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },

    // Confirmation of Delete Row
    async deleteSelectedRow() {
      // try {
      //   await this.$store.dispatch("routes/destroy", row);
      //   this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
      //   if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
      //     this.options.page -= 1; // Move to the previous page
      //   }
      //   this.toggleDeleteModal("close");
      //   this.fetchData();
      // } catch (error) {
      //   this.$store.dispatch("alerts/error", error.response?.data?.message);
      // }
    },
  },
};
</script>
<style scoped>
.row-box-wrap {
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 10px;
  /* Adds space between items */
}

.text-muted {
  color: #6c757d;
}

.highlighted {
  font-weight: bold;
}

.copy-button {
  margin-left: auto;
  /* Pushes the button to the far right */
}
</style>
